// import React, { useEffect, useState } from 'react';
// import { DataGrid } from '@mui/x-data-grid';
// import axios from 'axios';
// import { useHistory } from 'react-router-dom/cjs/react-router-dom';
// import { CheckToken } from '../login/AccessToken';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import { IconButton, Modal, Switch } from '@mui/material';
// import {
//     GridToolbarColumnsButton,
//     GridToolbarFilterButton,
//     GridToolbarDensitySelector,
// } from "@mui/x-data-grid";
// import CloseIcon from '@mui/icons-material/Close';
// import { useForm, Controller } from 'react-hook-form';
// import "./LabTest.scss";
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import UploadIcon from '@mui/icons-material/Upload';

// function LabTest() {
//     const [labTests, setLabTests] = useState([]);
//     const [authToken, setAuthToken] = useState(sessionStorage.getItem('accessToken') || '');
//     const [modalNewAddOpen, setNewAddModalOpen] = useState(false);
//     const [patientList, setPatientList] = useState('');
//     const [doctorsList, setDoctorsList] = useState([]);

//     const { register, handleSubmit, formState: { errors }, setError, getValues, control } = useForm();

//     const openNewAddModal = () => {
//         setNewAddModalOpen(true);
//     };

//     const closeNewAddModal = () => {
//         setNewAddModalOpen(false);
//     };
//     const history = useHistory();
//     const headers = {
//         Authorization: `Bearer ${authToken}`,
//     };
//     const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
//     const Token = () => {
//         const check = CheckToken();
//         setAuthToken(sessionStorage.getItem("accessToken"));
//         return check;
//     };
//     useEffect(() => {
//         if (!authToken || sessionStorage.getItem('roleType') !== 'lab user') {
//             history.push('/login');
//         }
//     }, []);

//     useEffect(() => {
//         if ((sessionStorage.getItem('roleType') === 'lab user') && CheckToken()) {
//             fetchLabTests();
//             fetchPatientList();
//             fetchDoctorList();
//         }
//     }, [authToken]);

//     const fetchPatientList = () => {
//         if (Token()) {
//             axios
//                 .get(
//                     `${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`,
//                     {
//                         headers: headers,
//                     }
//                 )
//                 .then((res) => {
//                     setPatientList(res.data);
//                 });
//         }
//     };
//     const fetchDoctorList = () => {
//         if (Token()) {
//             axios
//                 .get(
//                     `${REACT_APP_BACKEND_ROUTE_URL}get_doctors_based_on_facility_user/`,
//                     {
//                         headers: headers,
//                     }
//                 )
//                 .then((res) => {
//                     setDoctorsList(res.data);
//                 });
//         }
//     };
//     function fetchLabTests() {
//         axios.get(
//             `${REACT_APP_BACKEND_ROUTE_URL}get_patient_lab_tests/`,
//             { headers: headers }
//         )
//             .then((response) => {
//                 const labTestsData = response.data.lab_test_list.map((test, index) => ({
//                     ...test,
//                     id: index + 1 // Assign a unique identifier to each test object
//                 }));
//                 setLabTests(labTestsData);
//             })
//             .catch((error) => {
//                 console.log('FETCH FAILED:', error);
//             });
//     }
//     const handleSubmitNewAdd = (data) => {
//         console.log("data", data)
//         const requestData = {
//             "patient_id": "PAT_70",
//             "facility_id": "HLTHTEK_DEV",
//             "appointment_id": "appointment-6",
//             "doctor_id": "daed401c-0c02-45b8-beac-25e72cfb1edb",
//             "doctor_name": "Dr. Debjit Mondal",
//             "care_context_id": "REF-4jui29",
//             "test": ["Complete Blood Test", "Thyroid Function Test"]
//         }

//         axios.post(
//             `${REACT_APP_BACKEND_ROUTE_URL}add_patient_lab_tests/`, requestData,
//             { headers: headers })
//             .then((response) => {
//                 console.log(response.data)
//                 fetchLabTests()

//             })
//             .catch((error) => {
//                 console.log('FETCH FAILED:', error);
//             });

//     };

//     const handleStatusChange = ({ labTestId, testStatus, testName }) => {
//         const newStatus = testStatus === 'COMPLETED' ? 'PAID' : 'COMPLETED';
//         const requestBody = {
//             lab_test_id: labTestId,
//             test: testName,
//             status: newStatus
//         };

//         axios.post(`${REACT_APP_BACKEND_ROUTE_URL}edit_patient_lab_tests/`, requestBody, { headers })
//             .then(response => {
//                 fetchLabTests();
//                 console.log('Status updated successfully:', response.data);
//             })
//             .catch(error => {
//                 console.error('Failed to update status:', error);
//             });
//     };

//     const columns = [
//         { field: 'patient_id', headerName: 'Patient ID', width: 150 },
//         { field: 'patient_name', headerName: 'Patient Name', width: 200 },
//         { field: 'abha_id', headerName: 'Abha ID', width: 150 },
//         // { field: 'appointment_mode', headerName: 'Mode', width: 150 },
//         { field: 'test_name', headerName: 'Test And Procedure', width: 200 },
//         { field: 'doctor_name', headerName: 'Referred By', width: 200 },
//         { field: 'status', headerName: 'Status', width: 200 },
//         {
//             field: 'action',
//             headerName: 'Action',
//             width: 120,
//             renderCell: (params) => (
//                 <Switch
//                     checked={params.row.status === 'COMPLETED'}
//                     onChange={() => handleStatusChange({
//                         labTestId: params.row.lab_test_id,
//                         testStatus: params.row.status,
//                         testName: params.row.test_name
//                     })}
//                     color="primary"
//                     inputProps={{ 'aria-label': 'controlled' }}
//                 />

//             ),
//         },
//     ];

//     return (
//         <div style={{ height: "90vh", width: '100%' }}>
//             <h2 style={{ marginLeft: "25%" }}>Tests and Examinations</h2>

//             <div className="button-container">
//                 <button onClick={openNewAddModal} className="d-none d-xl-flex btn btn__primary btn__rounded ml-30"> + Add Tests</button>

//             </div>
//             <Modal open={modalNewAddOpen} onClose={closeNewAddModal} style={{ overflowY: "auto" }}>
//                 <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "15px" }}>
//                     <div className="col-sm-12 col-md-12 col-lg-7" style={{ marginLeft: "22%" }}>
//                         <div className="contact-panel mb-50">
//                             <IconButton onClick={closeNewAddModal} style={{ position: 'absolute', top: 0, right: 0 }}>
//                                 <CloseIcon />
//                             </IconButton>
//                             <form className="contact-panel__form" onSubmit={handleSubmit(handleSubmitNewAdd)}>
//                                 <div className="row">

//                                     {patientList && (
//                                         <div className="col-sm-6 col-md-6 col-lg-6">
//                                             <div className="form-group">
//                                                 <label htmlFor="patientId" className="required-label">Patient </label>
//                                                 <select
//                                                     className="form-control"
//                                                     name="patient_id"
//                                                     {...register("patient_id", {
//                                                         required: "Patient ID is required.",
//                                                     })}
//                                                 >
//                                                     <option value="" disabled>
//                                                         Select Patient
//                                                     </option>
//                                                     {patientList.map((patient) => (
//                                                         <option
//                                                             key={patient.patient_id}
//                                                             value={patient.patient_id}
//                                                         >
//                                                             {patient.name}
//                                                         </option>
//                                                     ))}
//                                                 </select>
//                                                 {errors.patientId && (
//                                                     <p className="errorMsg" style={{ color: "red" }}>
//                                                         {errors.patientId.message}
//                                                     </p>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     )}

//                                     {/* {doctorsList && (
//                                         <div className="col-sm-6 col-md-6 col-lg-6">
//                                             <label> select a doctor</label>
//                                             <div className="form-group">

//                                                 <select
//                                                     className="form-control"
//                                                     name="doctor_id"
//                                                     {...register("doctor_id", {
//                                                         required: "Doctor ID is required.",
//                                                     })}
//                                                 >
//                                                     <option value="" disabled>
//                                                         Select Doctor
//                                                     </option>
//                                                     {doctorsList.map((doctor) => (
//                                                         <option
//                                                             key={doctor.doctor_id}
//                                                             value={doctor.doctor_id}
//                                                         >
//                                                             {doctor.name}
//                                                         </option>
//                                                     ))}
//                                                 </select>
//                                             </div>
//                                         </div>
//                                     )} */}
//                                     <div className="col-sm-6 col-md-6 col-lg-6">
//                                         <div className="form-group">
//                                             <label htmlFor="first_name" className="required-label">First Name </label>
//                                             <input type="text" className='form-control' placeholder='Enter First Name' name="first_name" {...register("first_name", {
//                                                 required: "First Name is required.",
//                                             })} />
//                                             {errors.first_name && (
//                                                 <p className="errorMsg" style={{ color: "red" }}>{errors.first_name.message}</p>
//                                             )}
//                                         </div>
//                                     </div>
//                                     <div className="col-sm-6 col-md-6 col-lg-6">
//                                         <div className="form-group">
//                                             <label htmlFor="last_name" className="required-label">Last Name </label>
//                                             <input type="text" className='form-control' placeholder='Enter Last Name' name="last_name" {...register("last_name", {
//                                                 required: "Last Name is required.",
//                                             })} />
//                                             {errors.last_name && (
//                                                 <p className="errorMsg" style={{ color: "red" }}>{errors.last_name.message}</p>
//                                             )}
//                                         </div>
//                                     </div>
//                                     {/* <div className="col-sm-6 col-md-6 col-lg-6">
//                                         <div className="form-group">
//                                             <label htmlFor="doctorName" className="required-label">Doctor Name </label>
//                                             <input
//                                                 {...register("doctorName", { required: "Doctor Name is required" })}
//                                                 className="form-control"
//                                                 placeholder="Doctor Name"
//                                             />
//                                             {errors.doctorName && (
//                                                 <p className="errorMsg" style={{ color: "red" }}>
//                                                     {errors.doctorName.message}
//                                                 </p>
//                                             )}
//                                         </div>
//                                     </div> */}
//                                     <div className="col-sm-6 col-md-6 col-lg-6">
//                                         <div className="form-group">
//                                             <label htmlFor="serviceRequest" className="required-label">Test And Procedure</label>
//                                             <textarea
//                                                 {...register("testAndProcedure", { required: "Service Request is required" })}
//                                                 className="form-control"
//                                                 placeholder="Enter Test And Procedure (Separate items with comma)"
//                                             />
//                                             {errors.testAndProcedure && (
//                                                 <p className="errorMsg" style={{ color: "red" }}>
//                                                     {errors.testAndProcedure.message}
//                                                 </p>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <button type="submit" className="btn btn-primary">Submit</button>
//                             </form>
//                         </div>
//                     </div>
//                 </div>
//             </Modal>
//             <div style={{ height: 300, width: '100%' }}>
//                 {/* <DataGrid
//                  rows={labTests.filter(test => test.status !== 'NEW')}
//                     // rows={labTests}
//                     columns={columns}
//                     pageSize={5}
//                     autoHeight
//                     disableSelectionOnClick
//                     disableColumnMenu
//                     density="compact"
//                     pageSizeOptions={[5, 10]}
//                     getRowId={(row) => row.id}
//                     components={{
//                         Toolbar: () => (
//                             <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                                 <div style={{ display: 'flex' }}>
//                                     <GridToolbarColumnsButton />
//                                     <GridToolbarFilterButton />
//                                     <GridToolbarDensitySelector />
//                                 </div>
//                             </div>
//                         ),
//                     }}
//                 /> */}
//                 <DataGrid
//                     rows={labTests.filter(test => test.status !== 'NEW')}
//                     columns={columns}
//                     pageSize={5}
//                     autoHeight
//                     disableSelectionOnClick
//                     disableColumnMenu
//                     density="compact"
//                     pageSizeOptions={[5, 10]}
//                     getRowId={(row) => row.id}
//                     getRowClassName={(params) => {
//                         const status = params.row.status;
//                         if (status === 'COMPLETED') {
//                             return 'completed-row';
//                         } else if (status === 'PAID') {
//                             return 'paid-row';
//                         }
//                         return '';
//                     }}
//                     components={{
//                         Toolbar: () => (
//                             <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                                 <div style={{ display: 'flex' }}>
//                                     <GridToolbarColumnsButton />
//                                     <GridToolbarFilterButton />
//                                     <GridToolbarDensitySelector />
//                                 </div>
//                             </div>
//                         ),
//                     }}
//                 />

//             </div>
//         </div>
//     );
// }

// export default LabTest;

import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { CheckToken } from "../login/AccessToken";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { IconButton, Modal, Switch } from "@mui/material";
import {
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import CloseIcon from "@mui/icons-material/Close";
import { useForm, Controller } from "react-hook-form";
import "./LabTest.scss";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import UploadIcon from "@mui/icons-material/Upload"; // Import UploadIcon
import UploadFileModal from "../appointments/UploadFileModal";
import { toast } from "react-toastify";
import { displayPatientName } from "../../utils/displayPatientName";

function LabTest() {
  const [labTests, setLabTests] = useState([]);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") || ""
  );
  const [modalNewAddOpen, setNewAddModalOpen] = useState(false);
  const [patientList, setPatientList] = useState("");
  const [doctorsList, setDoctorsList] = useState([]);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false); // State for UploadFileModal
  const [abhaId, setAbhaId] = useState(""); // State to pass to UploadFileModal
  const [patientId, setPatientId] = useState(""); // State to pass to UploadFileModal
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    getValues,
    control,
  } = useForm();

  const openNewAddModal = () => {
    setNewAddModalOpen(true);
  };

  const closeNewAddModal = () => {
    setNewAddModalOpen(false);
  };
  const history = useHistory();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  // useEffect(() => {
  //   if (!authToken || sessionStorage.getItem("roleType") !== "lab user") {
  //     history.push("/login");
  //   }
  // }, []);
  const openUploadModal = (abhaId, patientId) => {
    setIsUploadModalOpen(true);
    setAbhaId(abhaId);
    setPatientId(patientId);
  };

  const closeUploadModal = () => {
    setIsUploadModalOpen(false);
  };

  useEffect(() => {
    if (sessionStorage.getItem("roleType") === "lab user" && CheckToken()) {
      fetchLabTests();
      fetchPatientList();
      fetchDoctorList();
    }
  }, [authToken]);
  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);
  const formatDate = (dateString) => {
    // Parse the date string
    const date = new Date(dateString);

    // Extract date components
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-indexed
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    // Construct formatted date string
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedDate;
  };

  const fetchPatientList = () => {
    if (Token()) {
      axios
        .get(
          `${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`,
          {
            headers: headers,
          }
        )
        .then((res) => {
          setPatientList(res.data?.data);
        });
    }
  };
  const fetchDoctorList = () => {
    if (Token()) {
      axios
        .get(
          `${REACT_APP_BACKEND_ROUTE_URL}get_doctors_based_on_facility_user/`,
          {
            headers: headers,
          }
        )
        .then((res) => {
          setDoctorsList(res.data?.data);
        });
    }
  };
  function fetchLabTests() {
    axios
      .get(`${REACT_APP_BACKEND_ROUTE_URL}get_patient_lab_tests/`, {
        headers: headers,
      })
      .then((response) => {
        const labTestsData = response.data.lab_test_list.map((test, index) => ({
          ...test,
          id: index + 1, // Assign a unique identifier to each test object
        }));
        setLabTests(labTestsData);
      })
      .catch((error) => {
        console.log("FETCH FAILED:", error);
      });
  }
  const handleSubmitNewAdd = (data) => {
    console.log("data", data);
    const requestData = {
      patient_id: "PAT_70",
      facility_id: "HLTHTEK_DEV",
      appointment_id: "appointment-6",
      doctor_id: "daed401c-0c02-45b8-beac-25e72cfb1edb",
      doctor_name: "Dr. Debjit Mondal",
      care_context_id: "REF-4jui29",
      test: ["Complete Blood Test", "Thyroid Function Test"],
    };

    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}add_patient_lab_tests/`,
        requestData,
        { headers: headers }
      )
      .then((response) => {
        console.log(response.data);
        fetchLabTests();
      })
      .catch((error) => {
        console.log("FETCH FAILED:", error);
      });
  };

  const handleStatusChange = ({ labTestId, testStatus, testName }) => {
    const newStatus = testStatus === "COMPLETED" ? "PAID" : "COMPLETED";
    const requestBody = {
      lab_test_id: labTestId,
      test: testName,
      status: newStatus,
    };

    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}edit_patient_lab_tests/`,
        requestBody,
        { headers }
      )
      .then((response) => {
        fetchLabTests();
        console.log("Status updated successfully:", response.data);
      })
      .catch((error) => {
        console.error("Failed to update status:", error);
      });
  };

  const columns = [
    { field: "patient_id", headerName: "Patient ID", width: 150 },
    {
      field: "patient_name",
      headerName: "Patient Name",
      width: 200,
      renderCell: (params) => displayPatientName(params.value),
    },
    { field: "abha_id", headerName: "Abha Address", width: 150 },
    // { field: 'appointment_mode', headerName: 'Mode', width: 150 },
    { field: "patient_phone_no", headerName: "PhoneNo", width: 180 },
    {
      field: "appointment_start_time",
      headerName: "Test Date",
      width: 200,
      valueGetter: (params) => formatDate(params.row.appointment_start_time),
    },
    { field: "test_name", headerName: "Test And Procedure", width: 200 },
    { field: "doctor_name", headerName: "Referred By", width: 200 },
    { field: "status", headerName: "Status", width: 200 },
    {
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: (params) => (
        <Switch
          checked={params.row.status === "COMPLETED"}
          onChange={() =>
            handleStatusChange({
              labTestId: params.row.lab_test_id,
              testStatus: params.row.status,
              testName: params.row.test_name,
            })
          }
          color="primary"
          inputProps={{ "aria-label": "controlled" }}
        />
      ),
    },
    {
      field: "upload",
      headerName: "Upload Record",
      headerAlign: "center",
      width: 150,
      renderCell: (params) => (
        <IconButton
          style={{ cursor: "pointer", display: "block", margin: "auto" }}
          onClick={() => {
            // const abhaId = params.row.abha_id;
            // if (!abhaId) {
            //   toast.error(
            //     "Unable to upload record as patient's ABHA ID is not present."
            //   );
            //   return;
            // }
            openUploadModal(params.row.abha_id, params.row.patient_id);
          }}
        >
          <UploadIcon />
        </IconButton>
      ),
    },
  ];

  return (
    <div style={{}}>
      <UploadFileModal
        isOpen={isUploadModalOpen}
        handleClose={closeUploadModal}
        abhaId={abhaId}
        patientId={patientId}
      />

      <h2 style={{ textAlign: "center" }}>Tests and Examinations</h2>

      {/* <div className="button-container">
        <button
          onClick={openNewAddModal}
          className="d-none d-xl-flex btn btn__primary btn__rounded ml-30"
        >
          {" "}
          + Add Tests
        </button>
      </div> */}

      <Modal
        open={modalNewAddOpen}
        onClose={closeNewAddModal}
        style={{ overflowY: "auto" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "15px",
          }}
        >
          <div
            className="col-sm-12 col-md-12 col-lg-7"
            style={{ marginLeft: "22%" }}
          >
            <div className="contact-panel mb-50">
              <IconButton
                onClick={closeNewAddModal}
                style={{ position: "absolute", top: 0, right: 0 }}
              >
                <CloseIcon />
              </IconButton>
              <form
                className="contact-panel__form"
                onSubmit={handleSubmit(handleSubmitNewAdd)}
              >
                <div className="row">
                  {patientList && (
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <div className="form-group">
                        <label htmlFor="patientId" className="required-label">
                          Patient{" "}
                        </label>
                        <select
                          className="form-control"
                          name="patient_id"
                          {...register("patient_id", {
                            required: "Patient ID is required.",
                          })}
                        >
                          <option value="" disabled>
                            Select Patient
                          </option>
                          {patientList.map((patient) => (
                            <option
                              key={patient.patient_id}
                              value={patient.patient_id}
                            >
                              {displayPatientName(patient.name)}
                            </option>
                          ))}
                        </select>
                        {errors.patientId && (
                          <p className="errorMsg" style={{ color: "red" }}>
                            {errors.patientId.message}
                          </p>
                        )}
                      </div>
                    </div>
                  )}

                  {/* {doctorsList && (
                                        <div className="col-sm-6 col-md-6 col-lg-6">
                                            <label> select a doctor</label>
                                            <div className="form-group">
                                              
                                                <select
                                                    className="form-control"
                                                    name="doctor_id"
                                                    {...register("doctor_id", {
                                                        required: "Doctor ID is required.",
                                                    })}
                                                >
                                                    <option value="" disabled>
                                                        Select Doctor
                                                    </option>
                                                    {doctorsList.map((doctor) => (
                                                        <option
                                                            key={doctor.doctor_id}
                                                            value={doctor.doctor_id}
                                                        >
                                                            {doctor.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    )} */}
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="first_name" className="required-label">
                        First Name{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter First Name"
                        name="first_name"
                        {...register("first_name", {
                          required: "First Name is required.",
                        })}
                      />
                      {errors.first_name && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors.first_name.message}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="last_name" className="required-label">
                        Last Name{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Last Name"
                        name="last_name"
                        {...register("last_name", {
                          required: "Last Name is required.",
                        })}
                      />
                      {errors.last_name && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors.last_name.message}
                        </p>
                      )}
                    </div>
                  </div>
                  {/* <div className="col-sm-6 col-md-6 col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="doctorName">Doctor Name </label>
                                            <input
                                                {...register("doctorName", { required: "Doctor Name is required" })}
                                                className="form-control"
                                                placeholder="Doctor Name"
                                            />
                                            {errors.doctorName && (
                                                <p className="errorMsg" style={{ color: "red" }}>
                                                    {errors.doctorName.message}
                                                </p>
                                            )}
                                        </div>
                                    </div> */}
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label
                        htmlFor="serviceRequest"
                        className="required-label"
                      >
                        Test And Procedure
                      </label>
                      <textarea
                        {...register("testAndProcedure", {
                          required: "Service Request is required",
                        })}
                        className="form-control"
                        placeholder="Enter Test And Procedure (Separate items with comma)"
                      />
                      {errors.testAndProcedure && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors.testAndProcedure.message}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </Modal>

      <DataGrid
        rows={labTests.filter((test) => test.status !== "NEW")}
        columns={columns}
        pageSize={5}
        autoHeight
        disableSelectionOnClick
        disableColumnMenu
        density="compact"
        pageSizeOptions={[5, 10]}
        getRowId={(row) => row.id}
        getRowClassName={(params) => {
          const status = params.row.status;
          if (status === "COMPLETED") {
            return "completed-row";
          } else if (status === "PAID") {
            return "paid-row";
          }
          return "";
        }}
        components={{
          Toolbar: () => (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "flex" }}>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
              </div>
            </div>
          ),
        }}
      />
    </div>
  );
}

export default LabTest;
